import styled, { css } from "styled-components";

export const TooltipContainer = styled.span`
  position: relative;
  display: flex;
  flex-direction: column;
`;

type GetTransformValue = "left" | "right" | "top-left";

export const getTransformValue = (position: GetTransformValue) => {
  switch (position) {
    case "left":
      return "translateY(50%)";
    case "right":
      return "translateY(50%)";
    case "top-left":
      return "translateX(-100%)";
    default:
      return "unset";
  }
};

type GetTopPosition = "bottom";
export const getTopPosition = (position: GetTopPosition) => {
  switch (position) {
    case "bottom":
      return "calc(100% + 4px)";
    default:
      return "unset";
  }
};

type GetRightPosition = "top-right" | "top-left" | "left";
export const getRightPosition = (
  position: GetRightPosition,
  bubbleWidth: number,
  width?: number
) => {
  switch (position) {
    case "top-right":
      return "0px";
    case "top-left":
      return `${width}px`;
    case "left":
      return `${bubbleWidth}px`;
    default:
      return "unset";
  }
};

type GetLeftPosition = "top-left" | "right";
export const getLeftPosition = (position: GetLeftPosition) => {
  switch (position) {
    case "top-left":
      return "0px";
    case "right":
      return "calc(100% + 4px)";
    default:
      return "unset";
  }
};

type GetBottomPosition = "left" | "right" | "bottom";

export const getBottomPosition = (
  position: GetBottomPosition,
  offsetHeight: number
) => {
  switch (position) {
    case "left":
      return "50%";
    case "right":
      return "50%";
    case "bottom":
      return "unset";
    default:
      return `${offsetHeight + 6}px`;
  }
};

type Position = "top" | "bottom" | "left" | "right";

export const TooltipBubble = styled.div<{
  position?: Position;
  offsetHeight: number;
  bubbleWidth: number;
  minWidth?: number;
  maxWidth?: number;
  width?: number;
  left?: string;
}>`
  min-width: ${(props) => (props.minWidth ? `${props.minWidth}px` : "120px")};
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : "210px")};
  width: ${(props) => (props.width ? `${props.width}px` : "100%")};
  position: absolute;
  z-index: 1003;
  border-radius: 4px;
  background-color: #222939;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33;
  color: #ffffff;
  padding: 8px;
  animation: fadein 0.2s ease-in;

  @media (max-width: 768px) {
    width: 100%;
    ${(props) =>
      props.left &&
      css`
        left: ${props.left};
      `}
  }

  @keyframes fadein {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  /* Position TOP */
  top: ${(props) => getTopPosition(props.position as GetTopPosition)};
  bottom: ${(props) =>
    getBottomPosition(props.position as GetBottomPosition, props.offsetHeight)};
  right: ${(props) =>
    getRightPosition(
      props.position as GetRightPosition,
      props.bubbleWidth,
      props.width
    )};
  left: ${(props) => getLeftPosition(props.position as GetLeftPosition)};
  transform: ${(props) =>
    getTransformValue(props.position as GetTransformValue)};
`;

export const TooltipMessage = styled.div`
  position: relative;
`;

export const TooltipTrigger = styled.div`
  display: inline-block;
`;
